import { useEffect, useState, useRef, FC } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useMeasure, useEffectOnce } from 'react-use';

import { INews } from 'ApiPackage/NewsModule/interfaces/INews';
import { CaptchaPopup } from 'CorePackage/CaptchaModule/components/CaptchaPopup';
import { newsGetData } from 'NewsPackage/MainModule/actions/newsActions';
import { NewsTypesEnum } from 'NewsPackage/MainModule/enums/NewsTypesEnum';
import { getNewsData } from 'NewsPackage/MainModule/selectors/newsSelectors';

import { PHONE_MIN, TABLET_MIN, DESKTOP_MIN } from '../constants/breakpoints';
import { SCREEN_MOBILE, SCREEN_TABLET, SCREEN_DESKTOP, SCREEN_LARGE_DESKTOP } from '../constants/screen';
import { Notifier } from './Notifier';
import { Announce } from './Announce';
import { Header } from './Header';
import { Footer } from './Footer';
import { Loader } from './Loader';
import { ButtonUp } from '../../../UIPackage/MainModule/components/ButtonUp';
import { getCoreIsLoading } from '../selectors/coreSelectors';
import { coreChangeView } from '../actions/coreActions';
import styles from './Layout.module.scss';
import { IRootState } from '../interfaces/IRootState';

interface ILayoutStoreProps {
  isLoading: boolean;
  newsData?: INews[];
}

const LayoutWithoutRoute: FC<ILayoutStoreProps> = ({ isLoading, children, newsData }) => {
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const dispatch = useDispatch();
  const [textAnnounce, setTextAnnounce] = useState<string>();
  const [headerTop, setHeaderTop] = useState<number | undefined>(0);
  const announceRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (newsData && newsData.length) {
      setTextAnnounce(newsData[0].text);
    }
  }, [newsData]);

  useEffectOnce(() => {
    dispatch(newsGetData(NewsTypesEnum.ANNOUNCEMENT));
  });

  useEffect(() => {
    if (textAnnounce && announceRef) {
      setHeaderTop(announceRef.current?.offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textAnnounce, width]);

  useEffect(() => {
    if (window.innerWidth < PHONE_MIN) {
      dispatch(coreChangeView(SCREEN_MOBILE));
    } else if (window.innerWidth < TABLET_MIN) {
      dispatch(coreChangeView(SCREEN_TABLET));
    } else if (window.innerWidth < DESKTOP_MIN) {
      dispatch(coreChangeView(SCREEN_DESKTOP));
    } else {
      dispatch(coreChangeView(SCREEN_LARGE_DESKTOP));
    }
  }, [width, dispatch]);

  return (
    <>
      {textAnnounce && <Announce ref={announceRef} text={textAnnounce} />}
      <Notifier />
      <Header style={{ top: `${headerTop}px` }} />
      <div className={styles.Wrapper}>
        <section ref={ref} className={styles.PageSection}>
          {children}
        </section>
        <Footer />
      </div>
      <Loader isLoading={isLoading} />
      <CaptchaPopup />
      <ButtonUp />
    </>
  );
};

const mapStateToProps = (state: IRootState): ILayoutStoreProps => ({
  isLoading: getCoreIsLoading(state),
  newsData: getNewsData(state, NewsTypesEnum.ANNOUNCEMENT),
});

export const Layout = connect(mapStateToProps)(LayoutWithoutRoute);
